import type { FC, ReactNode } from 'react'

import { SectionHeading } from '@/components/landing/section-heading'
import { BRAND_COLORS, BRAND_GRADIENT, BRAND_GRADIENT_CSS } from '@/constants/brand'

const SWATCHES = [
    { name: "Ember", hex: BRAND_COLORS.ember, role: "Gradient start" },
    { name: "Divi Red", hex: BRAND_COLORS.red, role: "Core brand color" },
    { name: "Rose", hex: BRAND_COLORS.rose, role: "Gradient end" },
    { name: "Ink", hex: BRAND_COLORS.ink, role: "Main background" },
    { name: "Night", hex: BRAND_COLORS.night, role: "Cards and surfaces" }
]

export const PaletteSection: FC = (): ReactNode => {
    return (
        <section id='colors' aria-labelledby='colors-title' className='border-t border-border py-24 sm:py-32'>
            <div className='mx-auto max-w-6xl px-6'>
                <SectionHeading id='colors-title' eyebrow="Color" title="Red, lit from the dark">
                    Divi Red carries the brand. Ember and Rose stretch it into the signature gradient, and Ink keeps every surface deep enough for the red to glow.
                </SectionHeading>

                <figure className='mt-14 overflow-hidden rounded-3xl border border-border'>
                    <div aria-hidden='true' className='h-28 sm:h-36' style={{ backgroundImage: BRAND_GRADIENT_CSS }} />

                    <figcaption className='flex flex-wrap items-center justify-between gap-2 bg-card px-6 py-4'>
                        <span className='font-heading text-sm font-semibold text-foreground'>
                            Signal gradient
                        </span>

                        <span className='font-mono text-xs text-muted-foreground'>
                            {BRAND_GRADIENT.map(stop => stop.color).join('  /  ')}
                        </span>
                    </figcaption>
                </figure>

                <ul className='mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5'>
                    {SWATCHES.map(swatch => (
                        <li key={swatch.name} className='overflow-hidden rounded-2xl border border-border bg-card'>
                            <div
                                aria-hidden='true'
                                className='h-24 shadow-[inset_0_0_0_1px_rgba(255,255,255,0.06)]'
                                style={{ backgroundColor: swatch.hex }}
                            />

                            <div className='p-4'>
                                <p className='font-heading text-sm font-semibold text-foreground'>
                                    {swatch.name}
                                </p>
                                <p className='mt-1 font-mono text-xs text-foreground/80'>
                                    {swatch.hex}
                                </p>
                                <p className='mt-2 text-xs text-muted-foreground'>
                                    {swatch.role}
                                </p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
